import {createStore} from "redux";
import {reducers} from "./reducers";
import {createBrowserHistory} from "history";
import {composeWithDevTools} from "redux-devtools-extension";
import storage from "redux-persist/lib/storage";
import {persistReducer, persistStore} from "redux-persist";

export const history = createBrowserHistory();

const persistConfig = {
    key: "socialDock",
    storage,
    whitelist: ["auth", "snsLists"],
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = createStore(persistedReducer, composeWithDevTools());

export let persistor = persistStore(store);
export default store;
